import { ContatoController } from "./contato/contato.controller";

(function () {
  "use strict";

  function PerfilRoute($stateProvider) {
    $stateProvider
      .state("perfil", {
        url: "/configuracoes-do-usuario?tour",
        template: require("./perfil.html"),
        redirectTo: "minha-conta",
        data: {
          headerMenuItems: [
            {
              icon: "perm_identity",
              text: "PERFIL",
              state: "minha-conta",
            },
            {
              icon: "supervisor_account",
              text: "CONTATOS",
              state: "contato",
            },
            {
              icon: "place",
              text: "ENDEREÇOS",
              state: "enderecos",
            },
            {
              icon: "local_grocery_store",
              text: "INTEGRAÇÕES",
              state: "integration",
            },
            {
              icon: "local_grocery_store",
              text: "REGRA FRETE",
              state: "regra-frete",
            },
            {
              icon: "local_grocery_store",
              text: "SIMULADOR FRETE",
              state: "simulador-frete",
            },
            {
              icon: "swap_horiz",
              text: "API",
              state: "api-config",
            },
          ],
        },
      })
      .state("contato", {
        parent: "perfil",
        url: "/contatos?abrirModalSetupContatos",
        template: require("./contato/contato.html"),
        controller: ContatoController,
        controllerAs: "vmContato",
        authenticate: true,
        data: {
          pageTitle: "Mandaê - A solução logística para o seu e-commerce",
        },
      })
      .state("minha-conta", {
        parent: "perfil",
        url: "/minha-conta",
        component: "appProfileSettings",
        authenticate: true,
        data: {
          pageTitle: "Mandaê - A solução logística para o seu e-commerce",
        },
      })
      .state("redirecionar", {
        url: "/redirecionar",
        template: require("./redirecionar/redirecionar.html"),
        controller: "PerfilRedirecionarController",
        authenticate: true,
      })
      .state("integration", {
        parent: "perfil",
        component: "appProfileIntegration",
        url: "/minhas-integracoes?showSetupDialog",
        authenticate: true,
        params: {
          showAlert: false,
        },
        data: {
          pageTitle: "Mandaê - A solução logística para o seu e-commerce",
        },
      })
      .state("regra-frete", {
        parent: "perfil",
        component: "appRegraFreteListagem",
        url: "/regra-frete",
        authenticate: true,
        data: {
          pageTitle: "Mandaê - A solução logística para o seu e-commerce",
        },
      })
      .state("regra-frete-criar", {
        parent: "perfil",
        component: "appRegraFreteCriar",
        url: "/regra-frete/criar/:id",
        authenticate: true,
        data: {
          pageTitle: "Mandaê - A solução logística para o seu e-commerce",
        },
      })
      .state("regra-frete-editar", {
        parent: "perfil",
        component: "appRegraFreteEditar",
        url: "/regra-frete/editar/:id",
        authenticate: true,
        data: {
          pageTitle: "Mandaê - A solução logística para o seu e-commerce",
        },
      })
      .state("simulador-frete", {
        parent: "perfil",
        component: "appSimuladorFrete",
        url: "/simulador-frete",
        authenticate: true,
        data: {
          pageTitle: "Mandaê - A solução logística para o seu e-commerce",
        },
      })
      .state("enderecos", {
        parent: "perfil",
        component: "appProfileAddress",
        url: "endereco",
        authenticate: true,
        data: {
          pageTitle: "Mandaê - A solução logística para o seu e-commerce",
        },
      });
  }

  angular.module("mandaeApp").config(PerfilRoute);
})();
